import * as React from "react";
import "./ColorTheme.css";

interface ColorBasedThemeProps {
  colors: string;
  verticalOrientation: boolean;
}

const ColorBasedTheme: React.FC<ColorBasedThemeProps> = ({ colors = "#FF0000,#FCFF00,#0EECFF", verticalOrientation }) => {
  return (
    <div
      style={{
        background: `linear-gradient(-45deg, ${colors})`,
        height: verticalOrientation ? "100vw" : "100vh",
        width: verticalOrientation ? "100vh" : "100%",
        overflow: "hidden",
        position: "relative",
        backgroundSize: "200% 200%",
	      animation: "gradient 5s ease infinite"
      }}
    ></div>
  );
};

export default ColorBasedTheme;
